export default __webpack_public_path__ + "static/media/cook-book.eb9236d7.png";